import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useApiFetch } from '../../shared/api'

/**
 * Delete a team's join code via the REST BFF
 * (DELETE /clubhouse/groups/{groupId}/join-code). Owner/Administrator only —
 * enforced server-side; the UI additionally hides the control from other roles.
 *
 * Once cleared, the old code no longer resolves, so nobody can join with it
 * until a new one is generated. We invalidate the my-groups query so the empty
 * state re-reads from its source of truth (`GroupDto.joinCode`).
 */
export function useClearJoinCode(groupId: string) {
  const call = useApiFetch()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () =>
      call<void>(`/clubhouse/groups/${encodeURIComponent(groupId)}/join-code`, {
        method: 'DELETE',
      }),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['clubhouse', 'me', 'groups'] })
    },
  })
}
